import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const BenefitCard = ({ image, title }) => (
  <div className="benefit-card">
    <div className="benefit-icon">
      <img src={image} alt={title} className="benefit-image" />
    </div>
    <p>{title}</p>
  </div>
);

export const LoanSimulatorSection = () => {
  // 🖼️ Rutas desde la carpeta public
  const benefits = [
    { image: "/images/icons/cronografo.png", title: "Crédito Aprobado Rápido" },
    { image: "/images/icons/dinero.png", title: "Cuotas Bajas" },
    { image: "/images/icons/motocicleta.png", title: "Amplio Catálogo" },
  ];

  return (
    <div className="loan-simulator">
      <div className="loan-simulator__left">
        <h3>¡TU MOTO IDEAL ESTÁ A UN CLICK!</h3>
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <BenefitCard
              key={index}
              image={benefit.image}
              title={benefit.title}
            />
          ))}
        </div>
      </div>

      <div className="loan-simulator__divider" />

      <div className="loan-simulator__right">
        <div className="loan-simulator__form">
          <Link to="/financiamiento">
            <button>Simula tu crédito aquí</button>
          </Link>
        </div>
      </div>
    </div>
  );
};
